// @flow
import * as React from 'react';
import type { Video, Image } from '../../models';
import type { UGCSection, UGCSectionHeaderComponent } from './UGCSection';
import AuthorInfo from './AuthorInfo';
import ReviewSection from './ReviewSection';
import { PwrMediaUgcMetaInfo, ClientMediaUgcMetaInfo } from './UgcMetaInfo';
import CollapsedBlock from './CollapsedBlock';
import UserGeneratedTextContainer from './UserGeneratedTextContainer';
import UgcLinkContext, { UgcLinkButton } from 'containers/UgcLinkContext';
import styles from './MediaSection.scss';

const Header: UGCSectionHeaderComponent = props => {
  const {
    ugc,
    options: { program },
  } = props;
  const parentUgc = ugc.getReview();
  const isAttachment = Boolean(parentUgc);

  if (isAttachment === false) {
    return <AuthorInfo ugc={ugc} />;
  }

  return program === 'pwr' ? null : <AuthorInfo ugc={ugc} />;
};

const getRelatedContent = (ugc, options) => {
  const { caption } = ugc;

  if (!caption) {
    return null;
  }

  return [
    <div className="dt center mv4 ph4" key="caption">
      <strong className={styles.mediaSectionCaptionLabel}>Caption:</strong>
      <span className={styles.mediaSectionCaptionText}>
        <UserGeneratedTextContainer data-key="caption" text={caption} />
      </span>
    </div>,
  ];
};

const provideCollapsedContent = (ugc, options, collapsedContentProps) => {
  const parentUgc = ugc.getReview();

  if (!parentUgc /* || options.program === 'client'*/) {
    return null;
  }

  const { onClick, open } = collapsedContentProps;
  const MetaInfoComponent =
    options.program === 'pwr' ? PwrMediaUgcMetaInfo : ClientMediaUgcMetaInfo;

  return (
    <CollapsedBlock label="Original Review" open={open} onClick={onClick}>
      <div className="mh4 mv3">
        <ReviewSection.Header ugc={parentUgc} options={options} />
      </div>
      <ReviewSection.Content ugc={parentUgc} options={options} />
      <MetaInfoComponent
        key="review-embed-attr"
        model={ugc}
        parentModel={parentUgc}
      />
      {options.program === 'client' && (
        <UgcLinkContext.Consumer>
          {linker => (
            <div className="mh4 dib">
              <UgcLinkButton
                href={linker(parentUgc)}
                label="View Original Review"
              />
            </div>
          )}
        </UgcLinkContext.Consumer>
      )}
    </CollapsedBlock>
  );
};

export const ImageSection: UGCSection = {
  Header,
  getRelatedContent,
  provideCollapsedContent,
  Content: props => {
    const { urlSet, caption } = (props.ugc: Image);

    return (
      <div className="ma4">
        <img
          src={urlSet.large}
          alt={caption}
          className={styles.mediaSectionImage}
        />
      </div>
    );
  },
};

export const VideoSection: UGCSection = {
  Header,
  getRelatedContent,
  provideCollapsedContent,
  Content: props => {
    const { urlSet, accessType } = (props.ugc: Video);

    if (accessType === 'upload') {
      return (
        <div className="ma4">
          <video
            height="auto"
            width="100%"
            controls
            className={styles.mediaSectionNativeVideo}
          >
            <source src={urlSet.raw} type="video/mp4" />
          </video>
        </div>
      );
    } else if (accessType === 'youtube') {
      return (
        <div className="ma4">
          <iframe
            height="auto"
            width="100%"
            src={urlSet.raw}
            style={{ border: 0, minHeight: 360 }}
            title="Youtube embed"
          />
        </div>
      );
    }
    return null;
  },
};



// WEBPACK FOOTER //
// ./src/components/ContentSection/MediaSection.js